import * as React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';

const Schools = () =>
  <Grid>
    <Row>
      <Col md={6} mdOffset={3}>
        <h2>Navštívili jsme</h2>
        <ul>
          <li>Českoslovanská akademie obchodní Dr. Edvarda Beneše, střední odborná škola, Praha 2, Resslova 8</li>
          <li>Dvořákovo gymnázium s Střední odborná škola ekonomická</li>
          <li>Evangelická akademie</li>
          <li>Gymnázium Boskovice, příspěvková organizace</li>
          <li>Gymnázium Čakovice</li>
          <li>Gymnázium F. X. Šaldy, Liberec 11, Partyzánská 530, příspěvková organizace</li>
          <li>Gymnázium Františka Palackého Valašské Meziříčí</li>
          <li>Gymnazium Jana Amose Komenského s.r.o </li>
          <li>Gymnázium Josefa Jungmanna, Litoměřice, Svojsíkova 1, příspěvková organizace</li>
          <li>Gymnázium mezinárodních a veřejných vztahů Praha s.r.o.</li>
          <li>Gymnázium Mikuláše Koperníka</li>
          <li>Gymnázium prof. Jana Patočky</li>
          <li>Gymnázium Sokolov a Krajské vzdělávací centrum, příspěvková organizace</li>
          <li>Gymnázium, Kukučínova ulica, Poprad</li>
          <li>Gymnázium, Písek, Komenského 89</li>
          <li>Gymnázium, Praha 4, Písnická 760</li>
          <li>Gymnázium, Praha 6, Arabská 14</li>
          <li>Gymnázium, Praha 9, Chodovická 2250</li>
          <li>Karlínská obchodní akademie a vyšší odborná škola ekonomická, Kollárova 5/271, Praha 8 </li>
          <li>Mensa gymnázium, o.p.s.</li>
          <li>Obchodní akademie Dušní</li>
          <li>Pražské humanitní gymnázium š.p.o.</li>
          <li>Slezské gymnázium, Opava, příspěvková organizace</li>
          <li>Smíchovská střední průmyslová škola</li>
          <li>Střední lesnická škola</li>
          <li>Střední odborná škola podnikatelská PROFIT, spol. s r. o.</li>
          <li>Střední odborná škola, Praha 5, Drtinova 3/498</li>
          <li>Střední odborné učiliště kadeřnické</li>
          <li>Střední průmyslová škola, Praha 10, Na Třebešíně 2299</li>
          <li>Střední škola gastronomická a hotelová s.r.o.</li>
          <li>Střední škola, základní škola a mateřská škola da Vinci</li>
          <li>Vyšší odborná škola ekonomických studií, Střední průmyslová škola potravinářských technologií a Střední odborná škola přírodovědná a veterinární, Praha 2, Podskalská 10</li>
          <li>Základní škola Kunratice</li>
          <li>Základní škola, Česká Lípa, Partyzánská 1053, příspěvková organizace</li>
          <br/>
          <li>Budějovický Majáles</li>
          <li>Dům dětí a mládeže Praha 2</li>
          <li>Eurocentrum Olomouc</li>
          <li>Euroepan Youth Event</li>
          <li>Jeden svět na školách</li>
          <li>Národní parlament dětí a mládeže</li>
          <li>Pardubický Barcamp</li>
          <li>Parlament dětí a mládeže města Ostravy</li>
          <li>Pražský parlament dětí a mládeže</li>
        </ul>
      </Col>
    </Row>
  </Grid>;

export default Schools;



// WEBPACK FOOTER //
// ./src/browser/Feature/Schools/index.jsx